exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.test-vue {\n    position: relative;\n}\n.test-vue > button {\n    position: fixed;\n    left: 0;\n    top: 400px;\n    z-index: 1000;\n}\n", ""]);

// exports
